import typography from "constants/typography.constants";
import TextFieldControl from "components/form/TextFieldControl";
import GenerateButton from "./GenerateButton";
import useRegenerateQuestion from "../hooks/useRegenerateQuestion";
import { GenerationType } from "../types";

interface GenerationFieldProps {
  name: string;
  label: string;
  successText: string;
  generationType: GenerationType;
  skillId: string | undefined;
  isEditing: boolean;
}

const GenerationField = ({ name, label, successText, generationType, skillId, isEditing }: GenerationFieldProps) => {
  const [handleRegenerateQuestion, { loading }] = useRegenerateQuestion({
    successText,
    generationTypes: [generationType],
    skillId,
  });

  return (
    <>
      <TextFieldControl
        name={name}
        disabled={!isEditing}
        label={label}
        placeholder={typography.form.placeholder.text}
      />
      <GenerateButton
        loading={loading}
        onClick={handleRegenerateQuestion}
        disabled={!isEditing}
      />
    </>
  );
};

export default GenerationField;
